import dayjs from 'dayjs';

import en from 'dayjs/locale/en';
import ptBr from 'dayjs/locale/pt-br';
import ru from 'dayjs/locale/ru';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { getLanguage } from '@app/services/i18n';

import { TIME_ZONES } from './constants';
export { TIME_ZONES } from './constants';

export const formatDate = (date?: string | Date | null): string => (date ? dayjs(date).format('DD.MM.YYYY') : '—');
export const formatDateAndTime = (date?: string | Date | null): string => {
  return date ? dayjs(date).format('D MMMM YYYY / HH:mm') : '—';
};
export const formatDateAndTimeShort = (date?: string | Date | null): string =>
  date ? dayjs(date).format('DD.MM.YY HH:mm') : '—';

export const fromUtc = (date?: string | null): Date | null => (date ? dayjs.utc(date).toDate() : null);

export const formatTimeInterval = (date1?: string | Date, date2?: string | Date): string => {
  if (!date1 || !date2) {
    return '';
  } else return `(${dayjs(date1).format('HH:mm')} - ${dayjs(date2).format('HH:mm')})`;
};

export const getTimeUntilStart = (startDate?: string | Date | null): string | null => {
  if (!startDate) {
    return null;
  }

  const start =
    typeof startDate === 'string' && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(startDate)
      ? dayjs.utc(startDate)
      : dayjs(startDate);
  const now = dayjs();
  const diffInMinutes = Math.max(Math.ceil(start.diff(now, 'second') / 60), 0);

  const days = Math.floor(diffInMinutes / 1440);
  const hours = Math.floor((diffInMinutes % 1440) / 60);
  const minutes = diffInMinutes % 60;

  return [
    days ? `${days} д` : null,
    hours ? `${hours} ч` : null,
    minutes || (!days && !hours) ? `${minutes} мин` : null,
  ]
    .filter(Boolean)
    .join(' ');
};

export const addMonths = (date: any, months: number) => {
  date.setMonth(date.getMonth() + months);
  return new Date(date).toISOString();
};

export const getCurrentTimeZone = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.guess();
  const guess = dayjs.tz.guess();
  const filteredZone = TIME_ZONES.find((el) => el.value === guess);
  const language = getLanguage();
  if (filteredZone?.value) {
    return filteredZone.value;
  } else if (language === 'ru') {
    return 'Europe/Moscow';
  } else if (language === 'pt') {
    return 'America/Buenos_Aires';
  } else {
    return 'Europe/London';
  }
};

export const setupDayJs = (value: string) => {
  if (value === 'ru') {
    return dayjs.locale(ru);
  } else if (value === 'pt') {
    return dayjs.locale(ptBr);
  } else {
    return dayjs.locale(en);
  }
};
